import {
  Component,
  inject,
  computed,
  ChangeDetectionStrategy,
} from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { ActivatedRoute } from "@angular/router";
import { ConfigService } from "../../shared/config/config.service";
import { pathRouteDataHelper$ } from "../../shared/helpers/path-params.helper";
import { AuthImagePipe } from "../../shared/pipes/auth-image.pipe";

@Component({
  selector: "claas-product-pictures",
  imports: [AuthImagePipe],
  templateUrl: "./product-pictures.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./product-pictures.scss",
})
export class ProductPicturesComponent {
  private route = inject(ActivatedRoute);
  config = inject(ConfigService);
  data = toSignal(pathRouteDataHelper$());
  pictures = computed(() => {
    return this.data()?.["pictures"];
  });
}
